module.exports = __webpack_public_path__ + "static/media/Carrier.86bf8f08.svg";